import React from "react";
//#region types
import { FormFieldProps } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import ReadOnlyField from "../baseFields/readOnlyField";
import CheckBox from "../baseFields/checkBox";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

function CheckBoxFormField<T extends Record<string, any>>(props: FormFieldProps<T>) {
  const { name, value, handleOnChange, handleOnBlurCustom, field, readonly } = props;

  return readonly ? (
    <ReadOnlyField label={field.label} href={field.href} className={cssExports.readOnlyTextField}>
      {value
        ? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Yes)
        : LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.No)}
    </ReadOnlyField>
  ) : (
    <CheckBox
      checked={!!value}
      name={name}
      onChange={handleOnChange.bind(null, name)}
      onBlur={handleOnBlurCustom.bind(null, name)}
      disabled={props.disabled}
      className={field.classes?.input}
    />
  );
}

export default CheckBoxFormField;
